import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class RaiseBecomeAMemberProcess extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	handleShowHideApplyButton = () => {
		const applyButton = this.selector.querySelector('.raise-tabs-head-template-button') as HTMLElement;
		const currentHash = window.location.hash;
		if ( currentHash && applyButton && currentHash === `#${applyButton.getAttribute('id')}` ) {
			applyButton.classList.add('hidden')
		} else {
			applyButton?.classList.remove('hidden')
		}
	}

	handleClickTab = ( tab: HTMLElement ) => {
		const tabId = tab.getAttribute( 'id' );
		if ( tabId ) {
			const oldTabActive = this.selector.querySelector( '.raise-tab-item.active' ) as HTMLElement;
			const oldTabContentActive = this.selector.querySelector(
				'.raise-become-member-tab-content.active',
			) as HTMLElement;
			const tabContent = this.selector.querySelector( `.raise-become-member-tab-content#${ tabId }` );
			const spanEl = this.selector.querySelector( '.tab-active-line' ) as HTMLElement;

			if ( oldTabActive ) {
				oldTabActive.classList.remove( 'active' );
			}
			if ( oldTabContentActive ) {
				oldTabContentActive.classList.remove( 'active' );
			}
			if ( tabContent ) {
				tabContent.classList.add( 'active' );
				tab.classList.add( 'active' );
			}
			tab.classList.add( 'active' );
			if(spanEl){
				spanEl.style.width = `${ tab.offsetWidth }px`;
				spanEl.style.left = `${ tab.offsetLeft }px`;
			}
			window.location.hash = tabId;
			this.handleShowHideApplyButton()
		}
	};

	handleWindowScroll() {
		const THIS = this
		window.addEventListener('scroll', function () {
			if (window.location.hash) {
				THIS.autoChangeTabByURL();
			}
		})
	}


	autoChangeTabByURL = () => {
		const currentHash = window.location.hash;
		const currentTab = this.selector.querySelector(`.raise-tab-item#${currentHash?.slice(1)}`) as HTMLElement;
		if (currentTab) {
			this.handleClickTab(currentTab)
		}
	}

	initActiveTabLine = () => {
		const tabsWrapper = this.selector.querySelector( '.raise-become-a-member-process-head' ) as HTMLElement;
		if ( tabsWrapper ) {
			const spanEl = document.createElement( 'span' );
			spanEl.className +=
				'tab-active-line absolute left-0 bottom-0 h-[6px] bg-purple-40 transition-all duration-300';
			tabsWrapper.appendChild( spanEl );
			const currentTabActive = this.selector.querySelector( '.raise-tab-item.active' ) as HTMLElement;
			if(spanEl){
				spanEl.style.width = `${ currentTabActive.offsetWidth }px`;
				spanEl.style.left = `${ currentTabActive.offsetLeft }px`;
			}
		}
	};

	handleClickApplyButton = (e: MouseEvent, applyButton: HTMLElement) => {
		e.preventDefault();
		const applyTab = this.selector.querySelector(`.raise-tab-item#${applyButton?.getAttribute('id')}`) as HTMLElement;
		applyTab && applyTab.click();
	}

	init() {
		const tabs = Array.from( this.selector.querySelectorAll( '.raise-tab-item' ) ) as HTMLElement[];
		this.handleWindowScroll()
		if ( tabs.length ) {
			const currentTabActive = this.selector.querySelector( '.raise-tab-item.active' ) as HTMLElement;
			if ( ! currentTabActive ) {
				const firstTab = tabs[ 0 ] as HTMLElement;
				const firstTabId = firstTab.getAttribute( 'id' );
				if ( firstTabId ) {
					firstTab.classList.add( 'active' );
					const tabContent = this.selector.querySelector(
						`.raise-become-member-tab-content#${ firstTabId }`,
					);
					if ( tabContent ) {
						tabContent.classList.add( 'active' );
					}
				}
			}
			tabs.forEach( tab => {
				tab.addEventListener( 'click', () => this.handleClickTab( tab ) );
			} );
		}
        setTimeout(() => {
			this.initActiveTabLine();
			if (window.location.hash) {
				this.autoChangeTabByURL();
			}
        }, 200)
		const processControlBtns = Array.from(
			this.selector.querySelectorAll( '.raise-become-member-process-control-btn, .raise-become-member-document-control-button' ),
		) as HTMLElement[];
		if ( processControlBtns.length ) {
			processControlBtns.forEach( item => {
				item.addEventListener( 'click', e => {
					e.preventDefault();

					const tabTarget = this.selector.querySelector(
						`.raise-tab-item#${ item.getAttribute( 'id' ) }`,
					) as HTMLElement;
					if ( tabTarget ) {
						this.handleClickTab( tabTarget );
					}
				} );
			} );
		}

		const timeChips = Array.from(
			this.selector.querySelectorAll( '.raise-become-member-process-step-time' ),
		) as HTMLElement[];
		const spaceTestRegex = /^\s*$/;
		if ( timeChips.length ) {
			timeChips.forEach( item => {
                const innerEle = item.querySelector('p') as HTMLElement;
				if ( !innerEle?.innerText || spaceTestRegex.test(innerEle?.innerText) ) {
					item.classList.add( 'hidden' );
				}
			} );
		}

		const documentControl = Array.from(
			this.selector.querySelectorAll( '.raise-become-member-document-control-wrapper' ),
		) as HTMLElement[];
        if (documentControl.length > 1) {
            documentControl[documentControl.length - 1].classList.add('last-document-control')
        }

		const applyButton = this.selector.querySelector('.raise-tabs-head-template-button') as HTMLElement;
		if (applyButton) {
			applyButton.addEventListener('click', (e) => this.handleClickApplyButton(e, applyButton))
		}

	}
}

export default RaiseBecomeAMemberProcess;
